
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Chemotherapy_WHO',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Chemotherapy_WHO.vue